import { Permissions } from "@cnx/common";
import {
  IconCarCrash,
  IconClockPause,
  IconUserCog,
  IconZoomQuestion,
} from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { useAuthStore } from "stores/authStore";
import { Link } from "types/Link";

export const useExceptionLinks = () => {
  const useRights = new Set(useAuthStore(state => state.useRights));
  const { t } = useTranslation();
  const { pathname: currentPath } = useLocation();

  const exceptionLinks: Link[] = [];

  useRights.has(Permissions.RIGHTS_EXCEPTION_TYPE_ADMIN) &&
    exceptionLinks.push({
      isActive: currentPath.startsWith("/exception-classes"),
      link: "/exception-classes",
      icon: <IconCarCrash />,
      label: t("classes"),
    });
  useRights.has(Permissions.RIGHTS_EXCEPTIONS_ADMIN) &&
    exceptionLinks.push({
      isActive: currentPath === "/exception-causes",
      link: "/exception-causes",
      icon: <IconZoomQuestion />,
      label: t("causes"),
    });
  useRights.has(Permissions.RIGHTS_EXCEPTIONS_ADMIN) &&
    exceptionLinks.push({
      isActive: currentPath === "/exception-waiting-reasons",
      link: "/exception-waiting-reasons",
      icon: <IconClockPause />,
      label: t("reasonForWaiting"),
    });
  useRights.has(Permissions.RIGHTS_EXCEPTIONS_ADMIN) &&
    exceptionLinks.push({
      isActive: currentPath.startsWith("/exception-responsible"),
      link: "/exception-responsible",
      icon: <IconUserCog />,
      label: t("exceptionResponsible"),
    });

  return exceptionLinks;
};
